import { List, Spin } from "antd";
import { useCallback, useState } from "react";
import Modal from "../../../../../components/generic/Modal";
import { useCases } from "../../../../../hooks/useCases";
import { parseError } from "../../../../../utils/shared";
import { setKeyValue } from "../../../../../store/chats/slice";
import { useDispatch } from "react-redux";
import { convertDateToFromNow } from "../../../../../utils/dayjs";

const CasesModal = ({ onCancel }) => {
  const { cases, loading, selectedTenantId } = useCases();
  const [submitting, setSubmitting] = useState(false);
  const dispatch = useDispatch();

  const onOk = useCallback(
    async (item) => {
      try {
        setSubmitting(true);
        dispatch(
          setKeyValue({
            key: "selectedCaseForm",
            value: item,
          }),
        );
        onCancel();
      } catch (error) {
        parseError(error);
      } finally {
        setSubmitting(false);
      }
    },
    [selectedTenantId],
  );

  return (
    <Modal
      title={"Cases"}
      open
      onCancel={onCancel}
      width={600}
      footer={null}
      isProcessing={submitting}
    >
      {loading ? (
        <div className="w-100 h-100 flex justify-center">
          <Spin />
        </div>
      ) : (
        <List
          itemLayout="horizontal"
          dataSource={cases}
          loading={submitting}
          renderItem={(item, index) => (
            <List.Item
              key={index}
              className="cursor-pointer"
              onClick={() => onOk(item)}
            >
              <List.Item.Meta
                avatar={
                  <span style={{ fontSize: "25px" }}>{item?.icon_emoji}</span>
                }
                title={item.name}
                description={item?.description}
              />

              <div
                style={{
                  color: "rgba(0, 0, 0, 0.45)",
                  fontSize: "14px",
                }}
              >
                {convertDateToFromNow(item?.created_at)}
              </div>
            </List.Item>
          )}
        />
      )}
    </Modal>
  );
};

export default CasesModal;
